export default function ComparisonStatsBar({ stats }) {
  if (!stats) return null;

  return (
    <div data-testid="comparison-stats-bar" className="rounded-2xl border border-zinc-800 bg-zinc-950/70 p-3">
      <div className="mb-2 flex items-center justify-between gap-3 text-xs text-zinc-500">
        <span>Préférences cumulées</span>
        <span>{stats.total_votes || 0} vote{stats.total_votes > 1 ? 's' : ''}</span>
      </div>
      <div className="grid gap-2 md:grid-cols-3">
        {stats.models?.map((item) => (
          <div
            key={item.model_key}
            data-testid={`comparison-stats-${item.model_key}`}
            className={`rounded-xl border px-3 py-2 text-sm ${
              stats.leader === item.model_key && item.votes > 0
                ? 'border-white bg-white/5 text-white'
                : 'border-zinc-800 bg-zinc-900/40 text-zinc-300'
            }`}
          >
            <div className="font-medium">{item.label}</div>
            <div className="mt-1 text-xs text-zinc-500">{item.votes} vote{item.votes > 1 ? 's' : ''} · {item.percentage}%</div>
          </div>
        ))}
      </div>
    </div>
  );
}
